import { ComponentType as e } from "../../registries/types/propTypes.js";
import f from "../audioplayer-transformer/audioplayer-transformer.js";
const b = (o) => {
  var i, p, s, u, w, _;
  const r = Array.isArray(o == null ? void 0 : o.article_overview) ? o == null ? void 0 : o.article_overview[0] : o == null ? void 0 : o.article_overview, A = Array.isArray(r == null ? void 0 : r.audio_player) && r.audio_player.length > 0 ? r : { audio_player: [r] };
  return {
    componentType: e.article_overview,
    tag: (i = r == null ? void 0 : r.overview) == null ? void 0 : i.tagline,
    title: (p = r == null ? void 0 : r.overview) == null ? void 0 : p.title,
    description: (s = r == null ? void 0 : r.overview) == null ? void 0 : s.description,
    subTitle: (u = r == null ? void 0 : r.overview) == null ? void 0 : u.sub_title,
    imageList: (_ = (w = r == null ? void 0 : r.image) == null ? void 0 : w.images) == null ? void 0 : _.map((v) => ({
      url: v == null ? void 0 : v.image.url,
      altText: v == null ? void 0 : v.alt_text,
      viewport: v == null ? void 0 : v.viewport
    })),
    audioFile: f(A)
  };
};
export {
  b as default
};
//# sourceMappingURL=article-overview-transformer.js.map
